/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ResendMyEmailCodeBody = zod.object({
  email: zod
    .email()
    .describe('The unverified address to re-send a code to. Must already be on the account.'),
});

export type ResendMyEmailCodeBody = zod.input<typeof ResendMyEmailCodeBody>;
export type ResendMyEmailCodeBodyOutput = zod.output<typeof ResendMyEmailCodeBody>;
